import React from 'react';
import './menu.scss';

const labels = {
  en: {
    label1: 'ABOUT',
    label2: 'SKILLS',
    label3: 'PORTFOLIO',
  },
  ru: {
    label1: 'ИНФО',
    label2: 'НАВЫКИ',
    label3: 'ПОРТФОЛИО',
  },
};

class Menu extends React.Component {
  componentDidMount = () => {
    document.getElementById(`b-${this.props.page}`).classList.add('active');
  };
  render() {
    const { switchPage, lang } = this.props;
    const { label1, label2, label3 } = labels[lang];
    return (
      <div className='Menu' onClick={switchPage}>
        <button id='b-0' className='btn btn-secondary'>
          {label1}
        </button>
        <button id='b-1' className='btn btn-secondary'>
          {label2}
        </button>
        <button id='b-2' className='btn btn-secondary'>
          {label3}
        </button>
      </div>
    );
  }
}

export default Menu;
